import styled from 'styled-components';
import BaseBox from '../design/BaseBox';

export const ContentWrapper = styled(BaseBox)`
  width: 100%;
  background-color: white;
  display: flex;
  min-height: 900px;
  max-width: 1400px;
  padding: 0 4rem;
  margin: 1rem auto;
  @media (max-width: 767px) {
    padding: 0 2rem;
  }
`;

export const TrackerWrapper = styled.div`
  // max-width: 1400px;
  margin: 2rem 0;
  padding: 3rem 0;
  background: #f7f7f8;
  border: 1px solid #d8d8d8;
`;

export const TrackerContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TrackerBlock = styled.div`
  position: relative;
  text-align: center;
  width: 100%;

  &:first-child {
    &:after {
      right: 0px;
      position: absolute;
      top: 30px;
      width: calc(49% - 1.75rem);
      content: '';
      border-bottom: 0.1rem solid #66cc00;
      box-sizing: border-box;

      @media (max-width: 767px) {
        top: 18px;
        width: calc(49% - 1rem);
      }
    }
    &:before {
      box-sizing: border-box;
    }
  }

  &:last-child {
    &:before {
      left: 0px;
      position: absolute;
      top: 30px;
      width: calc(49% - 1.75rem);
      content: '';
      border-bottom: 0.1rem solid #66cc00;
      box-sizing: border-box;

      @media (max-width: 767px) {
        top: 18px;
        width: calc(49% - 1rem);
      }
    }
    &:after {
      box-sizing: border-box;
    }
  }

  &:not(:first-child):not(:last-child) {
    &:after {
      right: 0px;
      position: absolute;
      top: 30px;
      width: calc(49% - 1.75rem);
      content: '';
      border-bottom: 0.1rem solid #66cc00;
      box-sizing: border-box;

      @media (max-width: 767px) {
        top: 18px;
        width: calc(49% - 1rem);
      }
    }
    &:before {
      left: 0px;
      position: absolute;
      top: 30px;
      width: calc(49% - 1.75rem);
      content: '';
      border-bottom: 0.1rem solid #66cc00;
      box-sizing: border-box;

      @media (max-width: 767px) {
        top: 18px;
        width: calc(49% - 1rem);
      }
    }
  }
`;

export const TrackerCircle = styled.span`
  display: inline-block;
  border: 2px solid ${prop => (prop.active ? '#4b286d' : '#4b286d')};
  border-radius: 49%;
  line-height: 1.7rem;
  width: 60px;
  height: 60px;
  margin-bottom: 1rem;
  background-color: ${prop => (prop.active ? '#4b286d' : '#FFF')};
  text-align: center;

  @media (max-width: 767px) {
    width: 35px;
    height: 35px;
  }
`;

export const TrackerTextContainer = styled.div`
  width: 95%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 0.75rem;
  @media (max-width: 767px) {
    display: none;
  }
`;

export const TrackerTextMobileContainer = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const TrackerText = styled.span`
  color: ${prop => (prop.active ? '#4b286d' : '#B895D7')};
  font-size: 16px;
  overflow-wrap: break-word;
  font-weight: 500;
`;

export const SignContractContainer = styled.span`
  font-size: 14px;
  margin-top: 0.5rem;

  @media (max-width: 767px) {
    margin-left: 2rem;
  }
`;

export const DetialLabel = styled.span`
  color: #4b286d;
  font-size: 18px;
`;

export const DetialValue = styled.span`
  margin-left: 1rem;
  color: #2a2c2e;
  font-size: 16px;
`;

export const SummaryRow = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 5px;
  margin-top: 0.5rem;
  display: flex;
`;

export const SummaryLabel = styled.span`
  color: #ababab;
  width: 250px;
  padding-right: 20px;
  padding: 10px;
  float: left;
  background: #f7f7f8;

  @media (max-width: 767px) {
    width: 175px;
  }
`;

export const SummaryValue = styled.span`
  // padding-right: 20px;
  padding: 10px;
  float: left;
`;

export const SummarySectionHeading = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #4b286d;
`;

export const SupportContainer = styled.div`
  width: 100%;
  margin: 0;
  padding: 1rem;
  background: #4b286d;
`;

export const SupportMain = styled.div`
  text-align: right;
  padding-right: 1.5rem;
`;

export const HelpTitle = styled.h3`
  color: #b895d7;
  font-size: 22px;
  font-weight: 500;
`;

export const HelpContent = styled.p`
  color: #b895d7;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.4px;
`;

export const HelpLink = styled.a`
  color: #b895d7;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.4px;

  &:hover {
    color: #b895d7;
    test-decoration: underline;
  }
`;

export const HoverIcon = styled.button`
  border: 1px solid #aaa;
  font-size: 14px;
  border-radius: 17px;
  width: 24px;
  background: #ddd;
  margin-left: 5px;
`;

export const WgLabel = styled.p`
  color: #4b286d;
  text-decoration: underline;
`;

export const CheckMarkContainer = styled.div`
  margin: 0.75rem;
  width: 30px;
  height: 30px;

  @media (max-width: 767px) {
    width: 15px;
    height: 15px;
    margin: 0.08rem 0.4rem;
  }
`;
